class MCartRemoveButton extends HTMLElement {
    constructor() {
        super(), this.addEventListener("click", (t => {
            t.preventDefault();
            (this.closest("m-cart") || this.closest("m-cart-drawer-items")).updateQuantity(this.dataset.index, 0)
        }))
    }
}

customElements.define("m-cart-remove-button", MCartRemoveButton);

class MCartTemplate extends HTMLElement {
    constructor() {
        super(), this.cartUpdateUnsubscriber = void 0, this.isCartPage = "cart" === MinimogSettings.templateName, this.cartDrawerWrapper = document.querySelector("m-cart-drawer"), this.cartDrawerInner = document.querySelector(".m-cart-drawer__inner"), this.mainCartItems = this.querySelector("[data-minimog-cart-items]"), this.cartSubTotal = this.querySelector("[data-cart-subtotal]"), this.cartDiscount = this.querySelector("[data-minimog-cart-discounts]"), this.giftWrapping = this.querySelector("[data-minimog-gift-wrapping]");
        let t = this.cartDrawerInner;
        this.isCartPage && (t = document.body), this.loading = new MinimogLibs.AnimateLoading(t, {overlay: t}), this.rootUrl = window.Shopify.routes.root;
        const e = debounce((t => {
            "id" !== t.target.name && this.onChange(t)
        }), 300);
        this.isCartPage ? this.mainCartItems.addEventListener("change", e.bind(this)) : this.addEventListener("change", e.bind(this)), MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, (t => {
            this.getCart().then((t => {
                this.updateCartCount(t.item_count)
            }))
        }))
    }

    updateCartCount(t) {
        document.querySelectorAll(".m-cart-count-bubble").forEach((e => {
            t > 0 ? (e.textContent = t, e.classList.remove("m:hidden")) : e.classList.add("m:hidden")
        }))
    }

    getCart() {
        return fetchJSON(this.rootUrl + "cart.json")
    }

    connectedCallback() {
        this.cartUpdateUnsubscriber = MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, (t => {
            "main-cart-items" !== t.source && this.onCartUpdate()
        }))

        this.renderBundleInfo();
    }

    disconnectedCallback() {
        this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber()
    }

    onCartUpdate(t = !0) {
        const {routes: e} = window.MinimogSettings;
        fetch(`${e.cart}.json`)
            .then(response => response.json())
            .then(cartData => {
                const firstProduct = cartData.items[0] || {};
                const productId = firstProduct.product_id;

                fetch(`${e.cart}?section_id=cart-template`)
                    .then(response => response.text())
                    .then(html => {
                        const doc = new DOMParser().parseFromString(html, "text/html");
                        const n = doc.querySelector("[data-minimog-cart-items]");
                        const r = doc.querySelector("[data-cart-subtotal]");
                        const subtotalPrice = doc.querySelector("[data-cart-subtotal-price]");
                        const a = doc.querySelector("[data-minimog-cart-discounts]");
                        const s = doc.querySelector("[data-minimog-gift-wrapping]");

                        this.updateRecommendations(productId);
                        this.updateShippingBarSection(cartData.total_price)

                        if (this.isCartPage) {
                            this.mainCartItems.innerHTML = n.innerHTML;
                            if (t) {
                                this.cartSubTotal.innerHTML = r.innerHTML;
                                this.cartDiscount.innerHTML = a.innerHTML;
                                this.giftWrapping.innerHTML = s.innerHTML;
                            }
                        }

                        const mCart = document.querySelector('.m-cart');
                        document.documentElement.style.setProperty('--m-cart-height', mCart.offsetHeight + 'px');
                        this.renderBundleInfo();
                    })
                    .catch(error => {
                        console.error('Error fetching cart HTML:', error);
                    });
            })
            .catch(error => {
                console.error('Error fetching cart JSON:', error);
            });
    }

    updateShippingCalculator() {
        const {routes: e} = window.MinimogSettings;
        fetch(`${e.cart}?section_id=cart-template`)
            .then(response => response.text())
            .then(html => {
                const doc = new DOMParser().parseFromString(html, "text/html");
                const shippingCalculator = document.querySelector("#m-cart-shipping-calculator");
                const shippingCalculatorResult = doc.querySelector("#m-cart-shipping-calculator");

                if (shippingCalculator && shippingCalculatorResult) {
                    shippingCalculator.innerHTML = shippingCalculatorResult.innerHTML;
                }
            })
            .catch(error => {
                console.error('Error fetching cart HTML:', error);
            });
    }

    onChange(t) {
        this.updateQuantity(t.target.dataset.index, t.target.value, document.activeElement.getAttribute("name"))
    }

    updateQuantity(t, e, i) {
        this.loading.start();
        const {routes: n} = window.MinimogSettings, r = JSON.stringify({
            line: t,
            quantity: e,
            sections: this.getSectionsToRender().map((t => t.section)),
            sections_url: window.location.pathname
        });
        fetch(`${n.cart_change_url}`, {...fetchConfig(), body: r}).then((t => t.text())).then((e => {
            const i = JSON.parse(e);
            let n = document.getElementById(`MinimogDrawer-quantity-${t}`);
            this.isCartPage && (n = MinimogTheme.config.mqlMobile ? document.querySelector(`.MinimogQuantity-${t}.MinimogQuantity-mobile`) : document.querySelector(`.MinimogQuantity-${t}.MinimogQuantity-desktop`));
            const r = document.querySelectorAll(".m-cart-item");
            if (i.errors) return this.loading.finish(), n.value = n.getAttribute("value"), void this.updateLiveRegions(t, i.errors);
            this.classList.toggle("m-cart--empty", 0 === i.item_count), this.cartDrawerWrapper && this.cartDrawerWrapper.classList.toggle("m-cart--empty", 0 === i.item_count), this.getSectionsToRender().forEach((t => {
                (document.getElementById(t.id).querySelector(t.selector) || document.getElementById(t.id)).innerHTML = this.getSectionInnerHTML(i.sections[t.section], t.selector)
            }));
            const a = i.items[t - 1] ? i.items[t - 1].quantity : void 0;
            let s = "";
            r.length === i.items.length && a !== parseInt(n.value) && (s = void 0 === a ? window.MinimogStrings.cartError : window.MinimogStrings.quantityError.replace("{{ quantity }}", a)), this.updateLiveRegions(t, s), MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, {
                ...i,
                source: "main-cart-items"
            })

            let productRecommendation = i.items[t - 1] || {};
            this.updateRecommendations(productRecommendation.product_id);
            this.updateShippingBarSection(i.total_price);
            this.renderBundleInfo();

        })).catch((() => {
        })).finally((() => {
            this.loading.finish()
            const mCart = document.querySelector('.m-cart');
            document.documentElement.style.setProperty('--m-cart-height', mCart.offsetHeight + 'px');
            this.renderBundleInfo();
        }))
    }

    updateLiveRegions(t, e) {
        let i = document.getElementById(`MinimogCartDrawer-Item-${t}`);
        this.isCartPage && (i = document.getElementById(`MinimogCart-Item-${t}`)), "" !== e && i && MinimogTheme.Notification.show({
            target: i,
            type: "warning",
            message: e
        })
    }

    getSectionInnerHTML(t, e) {
        return (new DOMParser).parseFromString(t, "text/html").querySelector(e).innerHTML
    }

    getSectionsToRender() {
        return [{
            id: "MinimogCart",
            section: "cart-template",
            selector: "[data-minimog-cart-items]"
        }, {id: "MinimogCart", section: "cart-template", selector: "[data-cart-subtotal]"}, {
            id: "MinimogCart",
            section: "cart-template",
            selector: "[data-minimog-cart-discounts]"
        }, {id: "MinimogCart", section: "cart-template", selector: "[data-minimog-gift-wrapping]"},
        {id: "MinimogCart", section: "cart-template", selector: "#m-cart-shipping-calculator"}
    ]
    }

    updateRecommendations(productId) {
        const recommendationsElement = document.querySelector('cart-recommendations');
        if (recommendationsElement && productId) {
            recommendationsElement.updateUrl(productId);
            recommendationsElement.loadRecommendations();
        } else {
            console.warn('cart-recommendations element not found or no productId.');
        }
    }

    updateShippingBarSection(cartTotal) {
        const shippingBarElement = document.querySelector('.bsf-volume-bar__status-bar_done');
        const totalPriceElement = document.querySelector('.bsf-volume-bar__cart__total-price');

        if (shippingBarElement) {
            const minimumFreeShipping = window.MinimogSettings.minimumFreeShipping;
            if (!minimumFreeShipping || isNaN(minimumFreeShipping)) {
                console.error('Minimum free shipping value is not defined or is not a number.');
                return;
            }

            if (!cartTotal) {
                shippingBarElement.closest('.bsf-volume-bar').classList.add('m:hidden');
            } else {
                shippingBarElement.closest('.bsf-volume-bar').classList.remove('m:hidden');
            }

            const shippingValue = minimumFreeShipping * 100;
            const shippingPercentageFraction = (cartTotal * 100) / shippingValue;
            let scaledPercentage;
            if (shippingPercentageFraction < 33.33) {
                scaledPercentage = shippingPercentageFraction * 0.25;
            } else if ( shippingPercentageFraction < 66.67) {
                scaledPercentage = shippingPercentageFraction * 0.75;
            } else {
                scaledPercentage = shippingPercentageFraction;
            }
            shippingBarElement.style.width = `${scaledPercentage}%`;
            totalPriceElement.textContent  = formatMoney(cartTotal, window.MinimogSettings.money_format);

            if (shippingPercentageFraction >= 100) {
                shippingBarElement.closest('.bsf-volume-bar__status__inner').classList.add('percent_100');
            } else {
                shippingBarElement.closest('.bsf-volume-bar__status__inner').classList.remove('percent_100');
            }

            if (shippingPercentageFraction >= 66.67) {
                shippingBarElement.closest('.bsf-volume-bar__status__inner').classList.add('percent_66_67');
            } else {
                shippingBarElement.closest('.bsf-volume-bar__status__inner').classList.remove('percent_66_67');
            }

            if (shippingPercentageFraction >= 33.33) {
                shippingBarElement.closest('.bsf-volume-bar__status__inner').classList.add('percent_33_33');
            } else {
                shippingBarElement.closest('.bsf-volume-bar__status__inner').classList.remove('percent_33_33');
            }


        }
    }

    renderBundleInfo() {
        document.querySelectorAll('.m-cart-drawer-item').forEach((t => {
            var original_price =parseInt(t.dataset.productOriginalPrice);
            var discount_application = parseInt(t.dataset.productDiscount);
            var product_type = t.dataset.productType;
            var product_antal = parseInt(t.dataset.productAntal);
            var suffix_unit = 'stk.';
            var qty_label_suffix = 'stk.';
            var is_divide_by_antal = false;
            var label = '';
            var quantity_label = '';

            for (var i = 0; i < bundle_constant.length; i++) {
                if (bundle_constant[i].product_type == product_type) {
                  suffix_unit = bundle_constant[i].suffix_unit;
                  qty_label_suffix = bundle_constant[i].qty_label_suffix;
                  if ((product_antal > 1) && bundle_constant[i].qty_label_suffix_plural) {
                    qty_label_suffix = bundle_constant[i].qty_label_suffix_plural;
                  }
                  if (bundle_constant[i].calc_rule == 'antal') {
                    is_divide_by_antal = true;
                  }
                }
            }

            if (product_antal > 0) {
                if (is_divide_by_antal) {
                    var bundle_price = original_price / product_antal;
                    if (discount_application > 0) {
                        var discount_amount = original_price * discount_application * 0.01;
                        bundle_price = (original_price - discount_amount) / product_antal;
                    }
                } else {
                    var bundle_price = original_price;
                    if (discount_application > 0) {
                        var discount_amount = original_price * discount_application * 0.01;
                        bundle_price = (original_price - discount_amount);
                    }
                }
                label = formatMoney(bundle_price, window.MinimogSettings.money_format) + ' / ' + suffix_unit;
                quantity_label = product_antal + ' ' + qty_label_suffix;
            } else {
                label = formatMoney(original_price, window.MinimogSettings.money_format) + ' / ' + suffix_unit;
            }
            t.querySelector('.m-cart-item__price_per_unit').innerHTML = label;
            if (t.querySelector('.m-cart-item__quantity-label')) {
                t.querySelector('.m-cart-item__quantity-label').innerHTML = quantity_label;
            }
        }))
    }
    
    /*
    updateRecommendations2(product) {
        const {routes: n} = window.MinimogSettings;
        if (product.product_id) {
            fetch(`${n.product_recommendations_url}?section_id=cart-drawer&product_id=${product.product_id}&limit=8`)
                .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    const recommendationsSection = html.querySelector('.cart--recommendations');
                    const currentRecommendationsSection = document.querySelector('.cart--recommendations');
                    if (recommendationsSection && currentRecommendationsSection) {
                        currentRecommendationsSection.innerHTML = recommendationsSection.innerHTML;
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        }
    }
    */
}

customElements.define("m-cart", MCartTemplate);
